// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2Eqrn","info":"PatientInfo_info__2Ksal"};